import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import Modal from '@perpay-web/components/base/Modal/Modal';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import { generatePhoneTemplateHref } from '@perpay-web/fintech/utils/routeUtils';
import { getClassName } from '@perpay-web/utils/domUtils';

import { CTA_DISPLAY_PHONE_NUMBER, CTA_PHONE_NUMBER } from './CtaPhoneNumber';
import styles from './IdentityVerificationRequired.scss';

const GetACallFromUsModal = ({ className, onClose }) => (
    <Modal
        className={className}
        containerClassName={styles['modal-container']}
        onClose={onClose}
        showClose={false}
    >
        <Stack className={styles['inner-stack']}>
            <Stack className={styles['inner-stack-tight']}>
                <p className={styles.subtitle}>We will contact you soon!</p>
                <p className={styles.copy}>
                    Thank you for choosing to verify your identity through a
                    call from us. Here’s what you can expect:
                </p>
                <ul className={styles.copy}>
                    <li>
                        We will contact you within the next business day to
                        verify your identity.
                    </li>
                    <li>
                        Please ensure you’re available at your registered
                        contact number during this time.
                    </li>
                </ul>
                <p className={styles.copy}>
                    If you need assistance sooner, you can always call us
                    directly at {CTA_DISPLAY_PHONE_NUMBER}.
                </p>
            </Stack>
            <Stack
                className={getClassName(
                    styles['inner-stack-tight'],
                    styles['modal-footer'],
                )}
            >
                <CardCta
                    action='primary'
                    Component={CustomButton}
                    onClick={onClose}
                >
                    Got it!
                </CardCta>
                <CustomLink
                    action='inline-link'
                    href={generatePhoneTemplateHref(CTA_PHONE_NUMBER)}
                    className={styles['modal-footer-link']}
                >
                    Call us now
                </CustomLink>
            </Stack>
        </Stack>
    </Modal>
);

export default GetACallFromUsModal;
